import styled from 'styled-components';
import theme from '../../const/theme';

export const ContactContainer = styled.div`
    max-width: 1250px;
    width: 100%;
    margin: 70px auto;
    padding: 0em;

    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100;

    }
`

export const ContactsTextWrapper = styled.div`
    text-align: center;
`

export const ContactWrapper = styled.div`
    width: 100%;
`

export const ContactRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${({ center }) => (center ? 'center' : 'space-between')}; ;
    padding: 50px 20px;
    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0;
        align-items: center;
    }
`

export const ContactInfoContainer = styled.div`
    padding-left: 60px;
    @media screen and (max-width: 768px){
        padding-left: 0;
        margin-top: 30px;
        margin-bottom: 30px;
    }

`
export const ContactElement = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 350px;
    text-decoration: none;

    .icon{
        color: ${theme.COLORS.PRIMARY};
    }
    .turn{
        transform: rotate(90deg);
    }

        &:hover .icon{
        color: ${theme.COLORS.DANGER};
        }
`

export const ContactText = styled.p`
    font-family: 'Roboto-regular', sans-serif;     
    font-weight: 600;
    color: #777;
    font-size: 17px;
    @media screen and (max-width: 768px){
        font-size: 15px;


    }
`

export const ContactsCard = styled.div`
    padding: 35px 50px;
    max-width: 49%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    margin: 0;
    height: 325px;
    border-radius: 50px;
    transition: all 0.2s ease-in-out;
    box-sizing: content-box;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 768px){
        margin-top: 30px;
        max-width: 85%;
        padding: 10px;
        width: 100%;
    }
    
`


export const ContactsIconContainer = styled.div`
    justify-content: center;
    align-content: center;
    display: flex;
    width: 60px;
    margin-right: 15px;
`

export const ContactsIcon = styled.img`
    height: 65px;
    width: ${({width}) => (width ? width : '60px')};
    margin-bottom: 10px;
`

export const ContactsH1 = styled.h1`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    opacity: ${({transparent}) => (transparent ? .5 : 1)};
    margin-bottom: ${({transparent}) => (transparent ? '10px' : '0px')};
    @media screen and (max-width: 768px){
        font-size: 2rem;
        text-align: center;

    }
`

export const ContactInput = styled.textarea`
    outline: none;
    border: none;
    box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.1);
    width: 80%;
    height: 150px;
    margin-top: 35px;
    margin-bottom: 35px;
    resize: none;
    padding: 10px;
`

export const ContactsH2 = styled.h2`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 1rem;
    font-weight:500;
    margin-bottom: 10px;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#000')};
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: .8rem;
        text-align: center;
    }
`
export const ContactsP = styled.p`
    font-family: 'Roboto-regular', sans-serif;     

    font-size: .8rem;
    text-align: center;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`
export const ContactsMapContainer= styled.div`
    max-width: 60%;
    width: 100%;
    height: 350px;
`

